'use strict';

angular.module('app')
  .controller('GisController', function (gettextCatalog, $timeout, $uibModal, $routeParams, $location, $rootScope, Booking, info) {
    var vm = this;
    vm.step = 'intro';
    vm.currentStepVerbose = 1;
    vm.info = info;
    vm.saveInfo = saveInfo;
    vm.bookingId = $routeParams.id;
    vm.selectStep = selectStep;
    vm.setNextStep = setNextStep;
    vm.setPrevStep = setPrevStep;
    vm.fileUpload = fileUpload;
    vm.getSizes = getSizes;
    vm.init = init;
    vm.allSteps = [
      {
        title: gettextCatalog.getString('Introduction'),
        nextStep: '1a',
        order: 1,
        key: 'intro',
      },
      {
        title: gettextCatalog.getString('Personal data'),
        formName: 'personalInfo',
        nextStep: '1b',
        key: '1a',
        prevStep: 'intro',
        delimeter: true,
        statusField: 'personalData',
        order: 2,
      },
      {
        title: gettextCatalog.getString('Contact details'),
        formName: 'contactDetails',
        key: '1b',
        nextStep: '1c',
        prevStep: '1a',
        statusField: 'contact',
        order: 3,
      },
      {
        title: gettextCatalog.getString('Emergency contact'),
        formName: 'emergencyContact',
        key: '1c',
        nextStep: '1d',
        prevStep: '1b',
        statusField: 'emergency',
        order: 4,
      },
      {
        title: gettextCatalog.getString('Passport'),
        formName: 'passportForm',
        key: '1d',
        nextStep: '1e',
        prevStep: '1c',
        statusField: 'passport',
        order: 5,
      },
      {
        title: gettextCatalog.getString('Insurance'),
        formName: 'diveInsurance',
        key: '1e',
        prevStep: '1d',
        nextStep: '1f',
        statusField: 'insurance',
        order: 6,
      },
      {
        title: gettextCatalog.getString('Diving Experience'),
        formName: 'divingExperience',
        key: '1f',
        prevStep: '1e',
        nextStep: '1g',
        statusField: 'divingXp',
        order: 7,
      },
      {
        title: gettextCatalog.getString('Equipment Related Information'),
        formName: 'equipmentForm',
        key: '1g',
        nextStep: '1h',
        prevStep: '1f',
        statusField: 'equipment',
        order: 8,
      },
      {
        title: gettextCatalog.getString('Special requirements'),
        formName: 'requirements',
        key: '1h',
        nextStep: '2',
        prevStep: '1g',
        statusField: 'specialRequirements',
        order: 9,
      },
      {
        title: gettextCatalog.getString('Travel details'),
        formName: 'transferForm',
        key: '2',
        prevStep: '1h',
        nextStep: 'intro',
        delimeter: true,
        statusField: 'travel',
        order: 10,
      },
    ];

    vm.steps = _.cloneDeep(vm.allSteps);

    init();

    function selectStep(step, direction) {
      vm.step = !$rootScope.user || vm.disableEdit ? 'intro' : step;

      if (vm.disableEdit) {
        $rootScope.showNotify(gettextCatalog.getString('This guest has claimed his account and only he/she can edit their own guest information now. Please click on the Email button to ask them to complete their information for this booking'));
      }
      setStep(step, direction);
    }

    function setStep(step, direction) {
      var nextStepItem = _.find(vm.steps, {key: step});
      if (!nextStepItem) {
        var removedStep = _.find(vm.allSteps, {key: step});
        selectStep(removedStep[direction === 'next' ? 'nextStep' : 'prevStep'], direction);
      } else {
        vm.currentStepVerbose = _.find(vm.steps, {key: step}).order;
        window.scrollTo(0, 0);
      }
    }

    function setNextStep(preventFormSubmit) {
      var currentStepItem = _.find(vm.steps, {key: vm.step});
      if (currentStepItem.formName && !preventFormSubmit) {
        saveInfo(vm[currentStepItem.formName], currentStepItem.key, function () {
          selectStep(currentStepItem.nextStep, 'next');
        }, 'next');
      } else {
        selectStep(currentStepItem.nextStep, 'next');
      }
    }

    function setPrevStep(preventFormSubmit) {
      var currentStepItem = _.find(vm.steps, {key: vm.step});

      if (currentStepItem.prevStep) {
        if (currentStepItem.formName && !preventFormSubmit) {
          saveInfo(vm[currentStepItem.formName], currentStepItem.key, function () {
            selectStep(currentStepItem.prevStep, 'prev');
          }, 'prev');
        } else {
          selectStep(currentStepItem.prevStep, 'prev');
        }
      }
    }

    function init() {
      if ($rootScope.user) {
        Booking.getAvailalbeFields($routeParams.uuid).then(function (items) {
          _.each(items, function (item, key) {
            if (key && !item) {
              vm.steps = _.reject(vm.steps, { statusField: key });
            }
          });
          vm.steps.forEach(function (step, index) {
            step.order = index + 1;
          });
          vm.visibleFields = items;
        });
        Booking.getGis($routeParams.id, $routeParams.uuid).then(function (data) {
          vm.form = data;
          vm.disableEdit = false;
          getFinishedSectionsNumber();
          if ($location.search().first_step) {
            selectStep('1a');
            $location.search({});
          }
        }).catch(function (error) {
          if (error && error.status === 403) {
            vm.disableEdit = true;
          }
        });
      }
    }

    function saveInfo(form, step, callback, direction) {
      form.$setSubmitted();

      vm.loading = true;

      if (window.innerWidth <= 1024 && form.$invalid && (direction === 'next' && step !== '2' || direction === 'prev')) {
        var modalInstance = $uibModal.open({
          animation: false,
          templateUrl: '../templates/_confirm-step-change.html',
          controller: function ($scope, $uibModalInstance) {
            var ctrl = this;
            ctrl.direction = direction;
            ctrl.editInfo = function () {
              $uibModalInstance.close(1);
            };
            ctrl.changeStep = function () {
              $uibModalInstance.dismiss(2);
            };
          },
          controllerAs: 'ctrl',
          backdrop: 'static',
          keyboard: false,
          windowClass: 'save-on-leave',
        });

        return modalInstance.result.then(function () {
          vm.loading = false;
        }, function () {
          callback();
          save();
        });
      }

      return save(true);

      function save(changeStep) {
        return Booking.saveGis($routeParams.id, $routeParams.uuid, vm.form, step).then(function (response) {
          vm.form.statuses = response;
          getFinishedSectionsNumber();

          if (changeStep && form.$valid) {
            direction === 'prev' ? setPrevStep(true) : setNextStep(true);
          }
        }).finally(function () {
          vm.loading = false;
        });
      }
    }


    function fileUpload(file, type) {
      vm.loading = true;
      var data = {};
      data[type] = file && file[0];

      Booking.saveGisFile($routeParams.id, $routeParams.uuid, data).then(function (response) {
        vm.form.statuses = response;
        var reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload =  function (e) {
          $timeout(function () {
            vm.form[type] = e.target.result;
          });
        };
      }).finally(function () {
        vm.loading = false;
      });
    }

    function getFinishedSectionsNumber() {
      vm.finishedSectionsNumber = _.reduce(vm.form.statuses, function (acc, status) {
        if (status) {
          acc += 1;
        }
        return acc;
      }, 0);
      console.log(vm.finishedSectionsNumber);
    }

    var sizes = {
      10: 'SHOE_SIZES_EU',
      20: 'SHOE_SIZES_US',
      30: 'SHOE_SIZES_UK',
    };

    function getSizes() {
      return vm.info.account[sizes[vm.form.shoeSizeUnit]];
    }
  });
